import React from 'react'

const TermsAndConditions = () => {
    return (
        <>
             <div className="pagepolicy">
                <div>
                    <h2 className='h2-policy'>TERMS & CONDITIONS</h2>
                      <p className='p-policy'>(Applicable to All Orders Placed on FabInsta)</p>
                </div>
                <div>
                    <h2 className='h2-policy'>1. Legal Status & Wholesale Model</h2>
                    <p className='p-policy'>FabInsta is a trade name owned and operated by Ultron Textiles LLP, Chennai, Tamil Nadu, India.</p>
                    <p className='p-policy'>FabInsta operates exclusively as a B2B wholesale textile platform. Membership and order placement are limited to business entities that regularly purchase fabric in bulk for commercial or industrial purposes.</p>
                    <p className='p-policy'> Ultron Textiles LLP reserves the right to:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Verify business credentials</li>
                        <li className='li-policy'>Request company documentation</li>
                        <li className='li-policy'>Approve, suspend, or terminate any account at its sole discretion</li>
                       </ul>
                </div>
                <div>
                    <h2 className='h2-policy'>2. Swatch Orders</h2>
                    <h3 className='h3-policy'>2.1 Availability</h3>
                    <p className='p-policy'> Swatch stock availability cannot be guaranteed.</p>
                    <p className='p-policy'> If a requested swatch becomes unavailable after order placement, the unavailable item will be automatically cancelled and refunded or credited, and remaining swatches will be shipped.</p>
                       <h3 className='h3-policy'>2.2 Sample Testing</h3>
                    <p className='p-policy'> Buyers are strongly advised to conduct preliminary testing before placing bulk yardage orders.</p>
                    <p className='p-policy'> Ultron Textiles LLP shall not be liable for damages resulting from:</p>
                     <ul className="ul-policy">
                        <li className='li-policy'>Improper laundering</li>
                        <li className='li-policy'>Incorrect processing</li>
                        <li className='li-policy'>Inappropriate handling</li>
                          <li className='li-policy'>Manufacturing incompatibility</li>
                           <p className='p-policy'> Repeated sample orders without corresponding bulk purchases may result in account restrictions.</p>
                       </ul>
                </div>
                <div>  <p className='p-policy'></p>
                    <h2 className='h2-policy'>3. Yardage Orders</h2>
                    <h3 className='h3-policy'>3.1 Colour Representation</h3>
                      <p className='p-policy'>Product photos and videos are for reference only. Actual colour and texture may vary.</p>
                        <p className='p-policy'>Ultron does not guarantee shade consistency across repeat orders.</p>
                          <p className='p-policy'>Lot-to-lot and dye-lot variations are industry-standard and do not constitute defects.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>4. Product Quality & Industry Tolerances</h2>
                    <p className='p-policy'>Textile products are subject to commercial tolerances including:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>GSM variation up to ±10%</li>
                        <li className='li-policy'>Shade variation</li>
                        <li className='li-policy'>Dye-lot variation</li>
                        <li className='li-policy'>Minor hand-feel differences</li>
                        <li className='li-policy'>Roll weight variation</li>
                        <li className='li-policy'>Meter conversion variance when sold by kilogram</li>
                      </ul>
                    <p className='p-policy'>Such variations do not constitute manufacturing defects.</p>
                    <p className='p-policy'>Buyers are advised to order approximately 7% additional quantity for production planning.</p>
                    <p className='p-policy'>Ultron Textiles LLP does not provide performance guarantees beyond standard commercial tolerances.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>5. Payment Terms</h2>
                    <p className='p-policy'>We accept:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Credit Cards</li>
                        <li className='li-policy'>Debit Cards</li>
                        <li className='li-policy'>Bank Transfers</li>
                       </ul>
                    <h3 className='h3-policy'>5.1 Processing Fees</h3>          
             <ul className="ul-policy">
                        <li className='li-policy'>A 2.5% processing fee applies to credit/debit card payments.</li>
                        <li className='li-policy'>No processing fee applies to bank transfers.</li>
                        <li className='li-policy'>Processing fees are non-refundable in case of customer-initiated refunds.</li></ul>
                    <p className='p-policy'>Title to goods shall pass only upon full realization of payment.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>6. Refund & Claim Policy</h2>
                    <h3 className='h3-policy'>6.1 No General Refunds</h3>
                    <p className='p-policy'>All sales are final.</p>
                       <p className='p-policy'>Refunds or exchanges are not permitted based solely on dissatisfaction or expectation mismatch.</p>
                    <h3 className='h3-policy'>6.2 Strict 4-Day Claim Requirement</h3>
                    <p className='p-policy'>Claims for:</p>
                      <ul className="ul-policy">
                        <li className='li-policy'>Must be submitted in writing within 4 calendar days of delivery confirmation, supported by photographic or video evidence.</li>
                        <li className='li-policy'>Failure to notify within 4 days constitutes deemed acceptance of goods.</li>
                        <li className='li-policy'>No claims shall be entertained thereafter.</li></ul>
                    <h3 className='h3-policy'>6.3 Non-Eligible Returns</h3>
                     <ul className="ul-policy">
                        <li className='li-policy'>Cut or processed fabric</li>
                        <li className='li-policy'>Customized orders</li>
                        <li className='li-policy'>Discounted or clearance products</li>
                          <li className='li-policy'>Goods not returned in original condition</li></ul>
                    <p className='p-policy'>All approved returns are subject to inspection. Ultron’s decision shall be final and binding.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>7. Order Modification</h2>
                    <p className='p-policy'>If a Buyer identifies an error after placing an order, a written request must be submitted immediately.</p>
                    <p className='p-policy'>Order modification is subject to production status and is not guaranteed.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>8. Stock & Production</h2>
                    <p className='p-policy'>Orders may be fulfilled from:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Existing inventory, or</li>
                        <li className='li-policy'>Fresh production batch</li>
                     </ul>
                       <p className='p-policy'>Real-time stock accuracy cannot be guaranteed.</p>
                         <p className='p-policy'>If production timelines exceed previously indicated estimates, confirmation may be sought before proceeding.</p>
                    <p className='p-policy'>Roll weights may vary and exact kilogram per roll cannot be guaranteed.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>9. Shipping Terms</h2>
                     <h3 className='h3-policy'>9.1 Address Modification</h3>
                    <p className='p-policy'>Shipping address cannot be modified after dispatch.</p>
                       <h3 className='h3-policy'>9.2 Transit Time</h3>
                    <p className='p-policy'>Transit time excludes order processing time and is indicative only.</p>
                          <p className='p-policy'>Delivery dates are estimates and subject to carrier performance.</p>
                          <h3 className='h3-policy'>9.3 Unattended or Refused Shipments</h3>
                    <p className='p-policy'>If shipments are refused or unattended:</p>
                    <ul className="ul-policy">
                        <li className='li-policy'>Goods may be discarded by the carrier</li>
                        <li className='li-policy'>Goods will not be returned</li>
                        <li className='li-policy'>No refund shall be issued</li>
                       </ul>
                    <p className='p-policy'>The Buyer is responsible for responding to logistics communication.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>10. Intellectual Property</h2>
                    <p className='p-policy'>All website content including logos, text, images, designs, software, templates, trademarks, and related materials are the exclusive intellectual property of FabInsta / Ultron Textiles LLP.</p>
                    <p className='p-policy'>Unauthorized copying, reproduction, distribution, or modification is strictly prohibited and may result in legal action.</p>
                    
                </div>
                <div>
                    <h2 className='h2-policy'>111. Limitation of Liability</h2>
                    <p className='p-policy'>To the maximum extent permitted by law:</p>
                     <ul className="ul-policy">
                        <li className='li-policy'>Ultron Textiles LLP’s total liability shall not exceed the invoice value of the specific order in dispute.</li>
                        <li className='li-policy'>Ultron shall not be liable for loss of profit, production loss, business interruption, third-party claims, or consequential damages.</li></ul>
                    <p className='p-policy'>The Buyer assumes full responsibility for downstream processing and usage.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>12. Governing Law & Jurisdiction</h2>
                    <p className='p-policy'>These Terms shall be governed by the laws of India.</p>
                    <p className='p-policy'>Courts located in Chennai, Tamil Nadu shall have exclusive jurisdiction over all disputes.</p>
                    <p className='p-policy'>Disputes shall first be referred to arbitration in Chennai under the Arbitration and Conciliation Act, 1996, by a sole arbitrator.</p>
                </div>
                <div>
                    <h2 className='h2-policy'>13. Modification of Terms</h2>
                    <p className='p-policy'>Ultron Textiles LLP reserves the right to amend these Terms at any time.</p>
                    <p className='p-policy'>Continued use of the website constitutes acceptance of updated terms.</p>
                </div>
            </div>
        </>
    )
}

export default TermsAndConditions
